<div class="content-block">
  <div class="flex flex-col sm:flex-row sm:items-center justify-center align-items-stretch gap-2">
    <select-tags [selectedTags]="selectedTags" (selectTagEvent)="selectTags($event)" />
    <span class="flex-1"></span>
    <mat-form-field class="w-full sm:w-auto" [subscriptSizing]="'dynamic'">
      <mat-label>View</mat-label>
      <mat-select [(ngModel)]="showArchivedView" (selectionChange)="switchActiveArchivedView()">
        <mat-option [value]="false" i18n>Active</mat-option>
        <mat-option [value]="true" i18n>Archived</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="flex flex-col items-center justify-start align-items-stretch gap-2 sm:flex-row">
    <div class="flex w-full sm:w-auto items-center sm:justify-center gap-1 order-1 sm:order-none">
      <select-all-items-checkbox
        [tooltip]="projectsLabel"
        [numAllItems]="numProjectsInView"
        [numSelectedItems]="numSelectedProjects()"
        (allSelectedEvent)="selectAllProjects()"
        (noneSelectedEvent)="unselectAllProjects()"
      />
      @if (numSelectedProjects() > 0) {
        <span class="secondary-text" i18n> {{ numSelectedProjects() }} selected </span>
        <archive-projects-button
          [showArchive]="!showArchivedView"
          (archiveProjectsEvent)="archiveProjects($event)"
        />
        <apply-tags-button [selectedProjects]="selectedProjects()" />
      }
    </div>
    <span class="flex-1 hidden sm:flex"></span>

    <mat-paginator
      class="self-end"
      [hidePageSize]="true"
      [length]="filteredProjects.length"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions"
      (page)="pageChange($event)"
    >
    </mat-paginator>
  </div>
  <div class="library__list flex flex-col flex-wrap items-start sm:flex-row">
    @for (project of filteredProjects; track project.id; let i = $index) {
      @if (isOnPage(i)) {
        <app-library-project
          [project]="project"
          [myUnit]="true"
          [checked]="projectIdToIsSelected()[project.id]"
          (projectSelectionEvent)="updateSelectedProjects($event)"
          class="w-full sm:w-1/2 lg:w-1/3"
        />
      }
    }
    @if (filteredProjects.length === 0) {
      <div class="notice" i18n>No units found.</div>
    }
  </div>
  <mat-paginator
    [length]="filteredProjects.length"
    [pageSize]="pageSize"
    [pageSizeOptions]="pageSizeOptions"
    (page)="pageChange($event, true)"
  >
  </mat-paginator>
</div>
